import { render, staticRenderFns } from "./PermisionItem.vue?vue&type=template&id=7598e057&scoped=true&"
import script from "./PermisionItem.vue?vue&type=script&lang=js&"
export * from "./PermisionItem.vue?vue&type=script&lang=js&"
import style0 from "./PermisionItem.vue?vue&type=style&index=0&id=7598e057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7598e057",
  null
  
)

export default component.exports